import React, { forwardRef } from "react";
import { ChevronRightIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import VqqQuestionRenderer from "./VqqQuestionRenderer";
import { extractSectionCode } from "./sectionCode";

const VqqSectionAccordion = forwardRef(({ section, isOpen, onToggle }, ref) => {
  if (!section) return null;

  const code = extractSectionCode(section.section);
  const total = section.question_count ?? 0;
  const approved = section.approved_count ?? 0;
  const isFullyApproved = total > 0 && approved >= total;
  const Chevron = isOpen ? ChevronDownIcon : ChevronRightIcon;

  return (
    <section ref={ref} aria-labelledby={`section-${code}-heading`} className="scroll-mt-24">
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center gap-3 rounded-lg border border-emerald-200 bg-emerald-50/60 px-4 py-3 text-left hover:bg-emerald-50 transition"
        aria-expanded={isOpen}
      >
        <Chevron className="h-4 w-4 text-emerald-700 shrink-0" aria-hidden="true" />
        <span className="inline-flex items-center justify-center min-w-[2.25rem] h-7 px-1.5 rounded text-xs font-semibold bg-emerald-100 text-emerald-700 border border-emerald-200 shrink-0">
          {code}
        </span>
        <h3
          id={`section-${code}-heading`}
          className="flex-1 text-base font-semibold text-gray-900 truncate"
        >
          {section.section}
        </h3>
        <span className="flex items-center gap-1.5 shrink-0">
          {isFullyApproved ? (
            <CheckCircleIcon className="h-5 w-5 text-emerald-600" aria-hidden="true" />
          ) : null}
          <span className="text-xs font-medium text-emerald-700 bg-emerald-100 border border-emerald-200 rounded-full px-2 py-0.5">
            {approved}/{total}
          </span>
        </span>
      </button>

      {isOpen ? (
        <ol className="space-y-3 mt-3">
          {(section.questions ?? []).map((q, idx) => (
            <li key={q.rfi_question_id}>
              <VqqQuestionRenderer question={q} index={idx + 1} />
            </li>
          ))}
        </ol>
      ) : null}
    </section>
  );
});

VqqSectionAccordion.displayName = "VqqSectionAccordion";

export default VqqSectionAccordion;
